import { PageHeader } from '@/components/PageHeader';
import { EmptyState } from '@/components/EmptyState';

export function ImportReviewPage() {
  return (
    <div>
      <PageHeader title="Import review" description="Staged historical import rows pending staff review." />
      <EmptyState title="Nothing to review" body="Full historical import is deferred — this page is the review UI shell." />
    </div>
  );
}
